import { getToken } from './tokenStore'
import { baseURL, httpservice } from "./httpService"
import axios from 'axios'

/**
 *  Initiate avanse Loan (BRE + Create Lead)
 */
export function initiateLoan(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/initiate-loan?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get loan status
 */
export function getLoanStatus(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/status/${detailId}`)
        .then(function (response) {
            return response.data?.response
        })
        .catch(function (error) {
            return error.data
        })
}

export function downloadKFSDoc(detailId) {
    const jwt = getToken()
    const auth = 'Bearer ' + jwt

    let URL = baseURL + `/api/v1/avanse/kfs/${detailId}`

    return new Promise((resolve, reject) => {
        axios.get(
            URL,
            {
                responseType: 'blob',
                headers: {
                    "Authorization": auth,
                    "Content-type": "application/pdf",
                },
            }
        ).then(function (response) {
            console.log("KFSDoc response:", response);
            resolve(response.data)
        }).catch(function (error) {
            return error.response
        })
    })
}


/**
 *  Initiate VKYC
 */
export function initiateVkyc(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/vkyc/initiate?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get VKYC status
 */
export function getVkycStatus(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/vkyc/status?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Initiate Esign
 */
export function initiateEsign(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/esign/initiate?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get Esign Status
 */
export function getEsignStatus(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/esign/status?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}



/**
 *  Create Mandate
 */
export function createMandate(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/mandate/create?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get Mandate Status
 */
export function getMandateStatus(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/mandate/status?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Create Payment
 */
export function createPayment(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/payment/create?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get Payment Status
 */
export function getPaymentStatus(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/payment/status?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}

/**
 *  Get Payment Status
 */
export function updateLeadApi(detailId) {
    return httpservice()
        .post(`/api/v1/avanse/update-lead?detailId=${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}


/**
 *  Get Payment Status
 */
export function getAvanseLoan(detailId) {
    return httpservice()
        .get(`/api/v1/avanse/${detailId}`)
        .then(function (response) {
            return response.data
        })
        .catch(function (error) {
            return error.data
        })
}